// extracted by mini-css-extract-plugin
export default {"VBMDevice__container":"VBMDevice_VBMDevice__container__S54Ed"};